<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_confirm_slip === true">ตรวจสอบสลิปถูกต้องเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div>
            <div class="mb-3 d-flex align-center">
                <h3 :class="customer_detail.status == 2 ? 'success--text' : customer_detail.status == 1 ? 'warning--text' : ''">คำสั่งซื้อ {{ customer_detail.number_order }}</h3>
                <div class="ml-2">สถานะ :
                    <span :class="customer_detail.status == 2 ? 'success--text' : customer_detail.status == 1 ? 'warning--text' : ''">{{ customer_detail.status == 2 ? 'สำเร็จ' : customer_detail.status == 1 ? 'กำลังดำเนินการ' : 'คำสั่งซื้อใหม่' }}</span>
                </div>
                <div class="ml-2">หมายเลขแทร็กกิ้ง :
                    <span>{{ customer_detail.track_number ? customer_detail.track_number  : '-'}}</span>
                </div>
            </div>
            <v-card class="mb-3">
                <div class="pa-3">
                    <div class="grid_header_content_order_detail_list col_sixtwotwo_content_order_detail_list">
                        <div>
                            <h4>ข้อมูลลูกค้า</h4>
                            <div>ชื่อลูกค้า : {{ customer_detail.full_name }}</div>
                            <div>ที่อยู่จัดส่ง : {{ customer_detail.address }}</div>
                            <div>เบอร์โทร : {{ customer_detail.tel }}</div>
                            <div>
                                <v-btn color="#28ab28" class="white--text" height="50" @click="printParcelOrder()">
                                    พิมพ์ใบสั่งพัสดุ
                                </v-btn>
                            </div>
                        </div>
                        <div>
                            <h4>การชำระเงิน</h4>
                            <div>ยอดชำระ : {{ customer_detail.total_price }} บาท</div>
                            <div v-if="customer_detail.payment_method == 0">
                                <v-btn color="#28ab28" class="white--text" width="100%" height="50" @click="open_confirm_slip = true" v-if="customer_detail.status == 0">
                                    สลิปถูกต้อง
                                </v-btn>
                                <div :class="customer_detail.status == 2 ? 'success--text' : customer_detail.status == 1 ? 'warning--text' : ''" v-if="customer_detail.status != 0">
                                    <div>ตวรจสอบการชำระเงินแล้ว</div>
                                    <div>ผู้ตรวจสอบ : {{ customer_detail.user_confirm }} {{ customer_detail.date_confirm }}</div>
                                </div>
                            </div>
                            <div v-if="customer_detail.payment_method == 1">
                                <div>( เก็บเงินปลายทาง )</div>
                                <v-btn color="#28ab28" class="white--text" width="100%" height="50" @click="open_confirm_slip = true" v-if="customer_detail.status == 0">
                                    ยืนยันคำสั่งซื้อ
                                </v-btn>
                                <div :class="customer_detail.status == 2 ? 'success--text' : customer_detail.status == 1 ? 'warning--text' : ''" v-if="customer_detail.status != 0">
                                    <div>ตวรจสอบการชำระเงินแล้ว</div>
                                    <div>ผู้ตรวจสอบ : {{ customer_detail.user_confirm }} {{ customer_detail.date_confirm }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-center align-center" v-if="customer_detail.payment_method == 0">
                            <div class="img_slip_content_order_detail_list cursor_content_order_detail_list" @click="open_slip = true">
                                <img :src="customer_detail.image_slip">
                            </div>
                        </div>
                    </div>
                </div>
            </v-card>
            <div class="mb-3">
                <h3>รายการสินค้า</h3>
            </div>
            <v-card>
                <div class="pa-3">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="text-center border_content_order_detail_list">
                                    รายการสินค้า
                                </th>
                                <th class="text-center border_content_order_detail_list">
                                    ราคาต่อหน่วย
                                </th>
                                <th class="text-center border_content_order_detail_list">
                                    จำนวน
                                </th>
                                <th class="text-center border_content_order_detail_list">
                                    ราคารวม
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(order_detail,index) in order_list" :key="index">
                                <td class="text-center border_content_order_detail_list" width="25%">
                                    <div class="d-flex align-center pa-2">
                                        <div class="img_detail_food_content_order_detail_list">
                                            <img :src="order_detail.image">
                                        </div>
                                        <div class="ml-2">{{ order_detail.name }}</div>
                                    </div>
                                </td>
                                <td class="text-center border_content_order_detail_list" width="25%">{{ order_detail.price }}</td>
                                <td class="text-center border_content_order_detail_list" width="25%">
                                    {{ order_detail.qty }}
                                </td>
                                <td class="text-center border_content_order_detail_list" width="25%">
                                    {{ order_detail.priceSum }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right border_content_order_detail_list" colspan="3">
                                    ค่าจัดส่ง
                                </td>
                                <td class="text-center border_content_order_detail_list" colspan="3">
                                    {{
                                        customer_detail.delivery_price
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right border_content_order_detail_list" colspan="3">
                                    รวมทั้งหมด
                                </td>
                                <td class="text-center border_content_order_detail_list" colspan="3">
                                    {{
                                        customer_detail.total_price
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
            </v-card>
        </div>
        <!-- เนื้อหา -->
        <v-dialog v-model="open_slip" persistent max-width="600px">
            <v-card>
                <v-card-title class="justify-space-between">
                    <div>
                        รูปภาพสลิป
                    </div>
                    <div class="cursor_content_order_detail_list" @click="open_slip = false">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-img height="330" max-width="280" v-if="imageSlipURL" :src="imageSlipURL" class="image_preview_content_order_detail_list"></v-img>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">

                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ยืนยันการส่งสลิป -->
        <v-dialog v-model="open_confirm_slip" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    คำเตือน
                </v-card-title>

                <v-card-text>
                    {{ customer_detail.payment_method == 0 ? 'สลิปนี้ถูกต้อง' : 'ต้องการยืนยันคำสั่งซื้อนี้' }} ใช่หรือไม่ ?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" @click="confirmSlip()">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" height="50" @click="open_confirm_slip = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import before_image from "@/assets/picture.png";
import contentorder from '@/api/content/contentpurchase/contentorder.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show_confirm_slip: false,
            open_confirm_slip: false,
            open_slip: false,
            customer_detail: null,
            order_list: [],
            imageSlipURL: before_image,
        }
    },
    methods: {
        currencyFormat,
        async orderDetail() {
            this.loading_page = true
            this.data = []
            let store_state_id = this.$route.params.type == 'ordermanage' ? this.$store.state.detailContentOrderId : this.$route.params.type == 'orderretrospect' ? this.$store.state.detailContentRetrospectId : null
            contentorder.orderDetail(store_state_id).then((response) => {
                if (response.data.successful === true) {
                    this.customer_detail = response.data.orderDtail
                    this.imageSlipURL = response.data.orderDtail.image_slip
                    this.order_list = response.data.orderList
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async printParcelOrder() {
            let store_state_id = this.$route.params.type == 'ordermanage' ? this.$store.state.detailContentOrderId : this.$route.params.type == 'orderretrospect' ? this.$store.state.detailContentRetrospectId : null
            window.open(
                `${process.env.VUE_APP_BASE_URL}pdfinvoice/?id=${store_state_id}`,
                '_blank'
            );
        },
        async confirmSlip() {
            this.open_confirm_slip = false
            this.loading_page = true
            let store_state_id = this.$route.params.type == 'ordermanage' ? this.$store.state.detailContentOrderId : this.$route.params.type == 'orderretrospect' ? this.$store.state.detailContentRetrospectId : null
            contentorder.confirmSlip(store_state_id).then((response) => {
                if (response.data.successful === true) {
                    this.orderDetail()
                    this.alert_show_confirm_slip = true
                    setTimeout(() => this.alert_show_confirm_slip = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
    },
    beforeCreate() {
        if (this.$route.params.type != 'ordermanage' && this.$route.params.type != 'orderretrospect') {
            this.$router.go(-1)
        }
    },
    mounted() {
        this.orderDetail()
    }
}
</script>

<style scoped>
.grid_header_content_order_detail_list {
    display: grid;
}

.col_sixtwotwo_content_order_detail_list {
    grid-template-columns: 60% 20% 20%;
}

.header_payment_content_order_detail_list {
    align-self: start;
}

.img_slip_content_order_detail_list {
    width: 120px;
}

.img_slip_content_order_detail_list>img {
    max-width: 100%;
}

.img_detail_food_content_order_detail_list {
    width: 90px;
}

.img_detail_food_content_order_detail_list>img {
    max-width: 100%;
}

.border_content_order_detail_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.cursor_content_order_detail_list {
    cursor: pointer;
}

.image_preview_content_order_detail_list {
    margin: auto;
}
</style>
